import { type SortKey } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type ExportTaskType } from '@webapp/modules/reports/entities/enums/ExportTaskTypeEnum'
import { type ReportExportTask } from '@webapp/modules/reports/entities/ReportExportTask'
import messages from './messages'
import { useQueryExportTasks } from '../../models/useQueryExportTasks'

export interface IUseExportTaskListPresenterParams {
  typeFilter: ExportTaskType[]
  dateRange: { from: string; to: string }
  onDeleteRequest: (task: ReportExportTask) => void
}

export const useExportTaskListPresenter = ({
  typeFilter,
  dateRange,
  onDeleteRequest,
}: IUseExportTaskListPresenterParams) => {
  const intl = useProcurifyIntl()

  const { items, isFetching } = useQueryExportTasks({ typeFilter, dateRange })

  // The backend soft-deletes and keeps returning inactive records, so the
  // post-delete refetch would resurrect deleted rows without this (BHV-037).
  const activeItems = items.filter((task) => task.isActive)

  // Server sort keys (BHV-035); the applied sort lives in the
  // REPORT_EXPORT_HISTORY pagination store (default -created_at, mode url).
  const sortOptions: SortKey[] = [
    {
      label: intl.formatMessage(messages.sortDatePreparedLabel),
      value: 'created_at',
    },
    {
      label: intl.formatMessage(messages.sortRequestedByLabel),
      value: 'user__lastName',
    },
  ]

  return {
    data: {
      items: activeItems,
      sortOptions,
    },
    methods: {
      onDeleteRequest,
    },
    states: {
      isFetching,
    },
  }
}
